<template>
  <div>
    <v-container grid-list-xl>
      <v-layout row>
        <v-flex xs12 sm12 md12 lg10 offset-lg1 xl8 offset-xl2>
          <h1 class="display-2 text-xs-center mb-2 mt-2">
            Utility and Vendor Resources
          </h1>
          <h2 class="subheading text-xs-center mb-3 font-italic logo-blue">
            We provide a few quick facts for Buyers and Sellers so just click on
            the tabs to reveal some useful information.
          </h2>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 sm12 md12 lg10 offset-lg1 xl8 offset-xl2>
          <the-resource-tabs></the-resource-tabs>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import TheResourceTabs from '../components/TheResourcesTabs';

export default {
  name: 'Resources',
  metaInfo: {
    title: 'Utility and Vendor Resources',
  },
  components: {
    TheResourceTabs,
  },
};
</script>
